import { render, staticRenderFns } from "./OpenClients.vue?vue&type=template&id=eadb783a&scoped=true"
import script from "./OpenClients.vue?vue&type=script&lang=ts"
export * from "./OpenClients.vue?vue&type=script&lang=ts"
import style0 from "./OpenClients.vue?vue&type=style&index=0&id=eadb783a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eadb783a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eadb783a')) {
      api.createRecord('eadb783a', component.options)
    } else {
      api.reload('eadb783a', component.options)
    }
    module.hot.accept("./OpenClients.vue?vue&type=template&id=eadb783a&scoped=true", function () {
      api.rerender('eadb783a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/OpenClients.vue"
export default component.exports